<template>
  <!-- Body -->
  <div class="d-flex flex-column align-center">
    <div id="building" @click="enter">
      <v-img
        v-if="portalEnabled"
        id="entrance"
        class="portal-effect"
        :src="portalSrc"
        lazy
      ></v-img>
    </div>
    <transition name="fade">
      <v-dialog v-model="portalClosedDialog" max-width="300" class="rounded-xl">
        <v-card class="pb-5" rounded="xl">
          <v-card-title
            class="
              text-h5
              teal--text
              text--darken-3
              d-flex
              justify-space-between
              pt-0
              pe-0
            "
          >
            <v-spacer></v-spacer>
            <CloseBtn
              size="30"
              :callback="
                () => {
                  portalClosedDialog = false;
                }
              "
            />
          </v-card-title>
          <v-card-text class="text-center">
            <v-img
              :src="require('@/assets/world/hamochi.png')"
              width="140"
              contain
              class="mx-auto"
            ></v-img>
            <div class="text-h6 font-weight-bold mt-3">
              {{ $t("view.PageWorldFun.portalClosedTitle") }}
            </div>
            <p class="text-body-2 mt-2">
              {{
                $t("view.PageWorldFun.portalClosedDescription", {
                  start: formatHour(portalStartHour),
                  end: formatHour(portalEndHour),
                })
              }}
            </p>
          </v-card-text>
        </v-card>
      </v-dialog>
    </transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  components: {
    CloseBtn: () =>
      import(
        /* webpackChunkName: "component-btn-close" */ "@/components/btns/CloseBtn"
      ),
  },
  computed: mapState({
    auth: (state) => state.auth.data,
    settings: (state) => state.settings.data,
  }),
  props: [
    //
  ],
  data: () => ({
    portalEnabled: false,
    portalSrc: require('@/assets/world/buildings/WordBuildingPortalEntrancex.png'),
    portalClosedDialog: false,
    portalStartHour: 18,
    portalEndHour: 22,
  }),
  created() {
    this.updatePortalEnabled();
  },
  mounted() {
    this.updatePortalEnabled();
  },
  methods: {
    updatePortalEnabled() {
      if (this.settings && this.settings.debug) {
        this.portalEnabled = true;
        return;
      }

      const startEnv = Number(process.env.VUE_APP_FUN_PORTAL_HOUR_START);
      const endEnv = Number(process.env.VUE_APP_FUN_PORTAL_HOUR_END);
      let startHour = Number.isInteger(startEnv) ? startEnv : 18;
      let endHour = Number.isInteger(endEnv) ? endEnv : 22;

      if (startHour < 0 || startHour > 23 || endHour < 1 || endHour > 24 || endHour <= startHour) {
        startHour = 18;
        endHour = 22;
      }

      this.portalStartHour = startHour;
      this.portalEndHour = endHour;
      const hours = new Date().getHours();
      this.portalEnabled = hours >= startHour && hours < endHour;
    },
    formatHour(hour) {
      const normalized = Number.isInteger(hour) ? hour : 0;
      const suffix = normalized >= 12 ? "pm" : "am";
      const display = normalized % 12 === 0 ? 12 : normalized % 12;
      return `${display}${suffix}`;
    },
    enter() {
      this.updatePortalEnabled();
      if (!this.portalEnabled) {
        this.portalClosedDialog = true;
        return;
      }
      this.$intro().exit();
      this.$router.push({ name: "PageFunArenaLanding" });
    },
  },
};
</script>

<style scoped>

#building {
  position: absolute;
  background-image: url("../../../assets/world/buildings/WorldBuildingFunArena.png");
  width: 1200px;
  height: 800px;
  bottom: 160px;
  background-size: contain;
  background-position: center bottom;
  background-repeat: no-repeat;
}

#entrance {
  cursor: pointer;
  position: absolute;
  width: 150px;
  height: auto;
  bottom: 90px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  z-index: 0;
  filter:
    drop-shadow(3px 0 0 rgba(255,255,255,0.3))
    drop-shadow(-3px 0 0 rgba(255,255,255,0.3))
    drop-shadow(0 3px 0 rgba(255,255,255,0.3))
    drop-shadow(0 -3px 0 rgba(255,255,255,0.3));
}

#entrance:hover {
  filter:
    drop-shadow(0 0 4px rgba(255, 255, 0, 0.8))
    drop-shadow(0 0 8px rgba(255, 255, 0, 0.6))
    drop-shadow(0 0 12px rgba(255, 255, 0, 0.4));
}

.portal-effect {
  animation: rotate-portal 3s linear infinite;
}

@keyframes rotate-portal {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
